import {
  AccountingImportDoctolibCsvApiResponseError,
  DoctorAttendingGenerateAccountingApiPayload,
  HttpErrors,
} from '@omecare/utils';
import { GenerateOfficeDoctorAttendingAccountingFormValues } from '@/components/forms/generate-office-doctor-attending-accounting-form/schema';
import { useGenerateOfficeDoctorAttendingAccountingUseForm } from '@/components/forms/generate-office-doctor-attending-accounting-form/use-generate-office-doctor-attending-accounting-form';
import { popTemplate, pushTemplate } from '@/components/templates';
import useGenerateAccountinOfficeDoctorAttendingMutation from '@/hooks/mutations/use-generate-office-doctor-attending-accounting';
import { popModal, pushModal } from '..';

export const useGenerateOfficeDoctorAttendingAccountingModalViewModel = () => {
  const {
    generateOfficeDoctorAttendingAccountingForm: generateAccountingForm,
  } = useGenerateOfficeDoctorAttendingAccountingUseForm();

  const closeModel = () => {
    popModal('GenerateOfficeDoctorAttendingAccountingModal');
  };

  const cancelModel = () => {
    popModal('GenerateOfficeDoctorAttendingAccountingModal');
  };

  const generateAccountingMutation =
    useGenerateAccountinOfficeDoctorAttendingMutation();

  const submit = (
    values: GenerateOfficeDoctorAttendingAccountingFormValues,
  ) => {
    const mutationPayload: DoctorAttendingGenerateAccountingApiPayload = {
      officeId: values.doctorAttending.officeId,
      doctorAttendingId: values.doctorAttending.doctorAttendingId,
      accountingMonth: values.accountingMonth,
      accountingYear: values.accountingYear,
    };
    generateAccountingMutation.mutate(mutationPayload, {
      onSuccess: (data) => {
        popModal('GenerateOfficeDoctorAttendingAccountingModal');

        pushTemplate('AccountingDoctorAttending', {
          data: {
            accounting: data,
            officeName: values.doctorAttending.officeName,
          },
          autoExport: true,
          onExportSuccess: () => {
            popTemplate('AccountingDoctorAttending');
          },
          onExportFailed: () => {
            popTemplate('AccountingDoctorAttending');
          },
        });
      },
      onError: (error: HttpErrors) => {
        if (!error.data) {
          console.error('Error data is missing', error);
          return;
        }
        pushModal('ImportAccountingDoctorAttendingCsvReportModal', {
          report: {
            error: error.data as AccountingImportDoctolibCsvApiResponseError,
          },
          officeId: values.doctorAttending.officeId,
        });
      },
    });
  };

  return {
    api: {
      submit: () => {
        generateAccountingForm.handleSubmit(submit)();
      },
      close: closeModel,
      cancel: cancelModel,
    },
    form: generateAccountingForm,
    data: {
      saving: generateAccountingMutation.isPending,
    },
  };
};

export type GenerateOfficeDoctorAttendingAccountingModalViewModel = ReturnType<
  typeof useGenerateOfficeDoctorAttendingAccountingModalViewModel
>;
